import { saveAs } from 'file-saver'
import { ClientLambdaApi } from '@/api-client.js'
import InitConfig from '@/app/sales_analysis/models/InitConfig.js'
import SalesAnalysisAgGrid from '@/app/sales_analysis/models/SalesAnalysisAgGrid.js'
import OneDimensionStrategy from '@/app/sales_analysis/models/OneDimensionStrategy'
import TwoDimensionStrategy from '@/app/sales_analysis/models/TwoDimensionStrategy'
import PayloadParametersBuilder from '@/app/sales_analysis/models/PayloadParametersBuilder'
import PivotParameters from '@/app/sales_analysis/models/PivotParameters'

const getInitConfig = async () => {
  const initConfig = await ClientLambdaApi.get('/so-analysis-parameter-config/')
  return new InitConfig(initConfig.data)
}

const getLongGrid = async ({ metrics, factTableName, dimension, strategyFilter, filters, calculatedField }) => {
  const longGridPayload = buildLongGridParameters({ metrics, factTableName, dimension, strategyFilter, filters, calculatedField })
  const longGrid = await ClientLambdaApi.post('/long-grid-data/', longGridPayload)
  return new SalesAnalysisAgGrid(longGrid.data)
}

const downloadLongGridToExcel = async ({ metrics, factTableName, dimension, strategyFilter, filters, calculatedField }) => {
  const longGridPayload = buildLongGridParameters({ metrics, factTableName, dimension, strategyFilter, filters, calculatedField })
  await downloadGridToExcel('long_grid', longGridPayload)
}

const getWideGrid = async ({ metrics, factTableName, productDimension, storeDimension, productStrategyFilter, storeStrategyFilter, filters }) => {
  const wideGridPayload = buildWideGridPayload({ metrics, factTableName, productDimension, storeDimension, productStrategyFilter, storeStrategyFilter, filters })
  const wideGrid = await ClientLambdaApi.post('/wide-grid-data/', wideGridPayload)
  return new SalesAnalysisAgGrid(wideGrid.data)
}

const downloadWideGridToExcel = async ({ metrics, factTableName, productDimension, storeDimension, productStrategyFilter, storeStrategyFilter, filters }) => {
  const wideGridPayload = buildWideGridPayload({ metrics, factTableName, productDimension, storeDimension, productStrategyFilter, storeStrategyFilter, filters })
  await downloadGridToExcel('wide_grid', wideGridPayload)
}

const downloadGridToExcel = async (type, parameters) => {
  const blobCsvFile = await ClientLambdaApi.post(`/download-grid-data-to-xlsx/?grid=${type}`, parameters, { responseType: 'blob' })
  saveAs(blobCsvFile.data, `${type}.xlsx`)
}

const buildLongGridParameters = ({ metrics, factTableName, dimension, strategyFilter, filters, calculatedField }) => {
  const oneDimensionStrategy = new OneDimensionStrategy(dimension, strategyFilter)
  const payloadParametersBuilder = new PayloadParametersBuilder({ metrics, factTableName, filters })
  const parameters = payloadParametersBuilder.build(oneDimensionStrategy)
  parameters.calculated_field = calculatedField
  return { parameters }
}

const buildWideGridParameters = ({ metrics, factTableName, productDimension, storeDimension, productStrategyFilter, storeStrategyFilter, filters }) => {
  const productStrategy = new OneDimensionStrategy(productDimension, productStrategyFilter)
  const storeStrategy = new OneDimensionStrategy(storeDimension, storeStrategyFilter)
  const twoDimensionStrategy = new TwoDimensionStrategy({ productStrategy, storeStrategy })
  const payloadParametersBuilder = new PayloadParametersBuilder({ metrics, factTableName, filters })
  const wideGridParameters = payloadParametersBuilder.build(twoDimensionStrategy)
  return wideGridParameters
}

const buildWideGridPivotParameters = (wideGridParameters) => {
  const indexDim = wideGridParameters.product_dimensions[0]
  const column = wideGridParameters.store_dimensions[0]
  return new PivotParameters(indexDim, column)
}

const buildWideGridPayload = ({ metrics, factTableName, productDimension, storeDimension, productStrategyFilter, storeStrategyFilter, filters }) => {
  const parameters = buildWideGridParameters({ metrics, factTableName, productDimension, storeDimension, productStrategyFilter, storeStrategyFilter, filters })
  const pivotParameters = buildWideGridPivotParameters(parameters)
  return { parameters, pivotParameters }
}

const getDateGranularityConfig = async (factTableName) => {
  const dateGranularityConfig = await ClientLambdaApi.get(`/date-agg-report-config/?fact_table=${factTableName}`)
  return dateGranularityConfig.data
}

const getSalesComparative = async (parameters) => {
  const salesComparative = await ClientLambdaApi.post('/sales-comparative', { parameters })
  return salesComparative.data
}

export { getInitConfig, getLongGrid, getWideGrid, downloadLongGridToExcel, downloadWideGridToExcel, getDateGranularityConfig, getSalesComparative }



// WEBPACK FOOTER //
// ./src/app/sales_analysis/Services.js